import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { ProductComparator, AllProductsComparator, PagedListInputRequest, Competitor, AdicionarProdutoComparacao, AddProductResult, Laboratory } from 'src/app/api/models/product-comparator';
import { ProductComparatorService } from 'src/app/api/services';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ComparatorModalComponent } from './comparator-modal/comparator-modal.component';
import { ENTER } from '@angular/cdk/keycodes';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';

@Component({
    selector: 'app-product-comparator',
    templateUrl: './product-comparator.component.html',
    styleUrls: ['./product-comparator.component.css'],
    standalone: false
})

export class ProductComparatorComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  request: PagedListInputRequest = {
    Page: 1,
    PageSize: 10,
    SortColumn: 'DataAdicionado',
    SortOrder: 'desc',
    FilterName: '',
    FilterValue: ''
  };
  comparatorListCurrentPage: number = 1;
  comparatorPageSize: number = 10;
  //comparatorPageSizeOptions: number[] = [5,10,20,30,50];
  comparatorPageSizeOptions: number[] = [];
  separatorKeysCodes: number[] = [ENTER];
  chipsList: string[] = [];
  searchControl = new FormControl('');
  subscription: Subscription = new Subscription();
  productsComparator!: AllProductsComparator;
  dataSourceComparator: MatTableDataSource<ProductComparator> = new MatTableDataSource();
  productsComparatorDisplay: ProductComparator[] = [];
  apiResponse: number = 0;
  nextPage: boolean = false;
  competitors: Competitor[] = [];
  laboratories: Laboratory[] = [];
  labs: string[] = [];
  selectedLab: string[] = [];
  stores: number[] = [];
  selectedStore: number[] = [];
  storesFilter: number[] = [];
  selectedStoreFilter: number[] = [];
  addProduct: AdicionarProdutoComparacao = {
    ProductsIds: [],
    LabsIds: [],
    CompetitorsIds: []
  };
  searchFilter: string = '';
  @ViewChild('comparatorListPaginator') paginator!: MatPaginator;
  @ViewChild('downloadLink') downloadLink!: ElementRef;

  constructor(
    private productComparatorService: ProductComparatorService,
    private snackBarService: SnackBarService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadComparations();
    this.loadCompetitors();
    this.loadLaboratories();
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => (value ?? '').length >= 3 || (value ?? '').length === 0)
    ).subscribe(query => {
      this.filterProducts((query ?? ''));
    });
  }
  
  onStoreChange(selected: number[]) {
    const allIds = this.competitors.map(c => c.idConcorrente);
    
    if (selected.includes(0))
    {
      if (this.selectedStore.includes(0) && selected.length == allIds.length ){
        this.stores = selected.filter(id => id !== 0);
        selected = this.stores;
        this.selectedStore = this.stores;
      }
      else 
      {
        selected = [0,...allIds]
        this.stores = [0,...allIds];
        this.selectedStore = [0,...allIds];
      }
    }
    else
    {
      if (this.selectedStore.includes(0)){
        selected = []
        this.stores = [];
        this.selectedStore = [];
      }
      else
      {
        if (this.selectedStore.includes(0))
        {
          this.selectedStore = [];
          this.stores = [];
          this.selectedStore = selected;
          this.stores = selected;
        }
        else if (selected.length == allIds.length)
        {
          selected = [0,...allIds]
          this.stores = [0,...allIds];
          this.selectedStore = [0,...allIds];
        }
        else
        {
          this.stores = selected;
          this.selectedStore = selected;
        }
      }
    }
  }

  onLabChange(selected: string[]) {
    const allIds = this.laboratories.map(l => l.id);
    
    if (selected.includes('0'))
    {
      if (this.selectedLab.includes('0') && selected.length == allIds.length ){
        this.labs = selected.filter(id => id !== '0');
        selected = this.labs;
        this.selectedLab = this.labs;
      }
      else 
      {
        selected = ['0',...allIds]
        this.labs = ['0',...allIds];
        this.selectedLab = ['0',...allIds];
      }
    }
    else
    {
      if (this.selectedLab.includes('0')){
        selected = []
        this.labs = [];
        this.selectedLab = [];
      }
      else
      {
        if (this.selectedLab.includes('0'))
        {
          this.selectedLab = [];
          this.labs = [];
          this.selectedLab = selected;
          this.labs = selected;
        }
        else if (selected.length == allIds.length)
        {
          selected = ['0',...allIds]
          this.labs = ['0',...allIds];
          this.selectedLab = ['0',...allIds];
        }
        else
        {
          this.labs = selected;
          this.selectedLab = selected;
        }
      }
    }
  }

  onStoreChangeFilter(selected: number[]) {
    const allIds = this.competitors.map(c => c.idConcorrente);
    
    if (selected.includes(0))
    {
      if (this.selectedStoreFilter.includes(0) && selected.length == allIds.length ){
        this.storesFilter = selected.filter(id => id !== 0);
        selected = this.storesFilter;
        this.selectedStoreFilter = this.storesFilter;
      }
      else 
      {
        selected = [0,...allIds]
        this.storesFilter = [0,...allIds];
        this.selectedStoreFilter = [0,...allIds];
      }
    }
    else
    {
      if (this.selectedStoreFilter.includes(0)){
        selected = []
        this.storesFilter = [];
        this.selectedStoreFilter = [];
      }
      else
      {
        if (this.selectedStoreFilter.includes(0))
        {
          this.selectedStoreFilter = [];
          this.storesFilter = [];
          this.selectedStoreFilter = selected;
          this.storesFilter = selected;
        }
        else if (selected.length == allIds.length)
        {
          selected = [0,...allIds]
          this.storesFilter = [0,...allIds];
          this.selectedStoreFilter = [0,...allIds];
        }
        else
        {
          this.storesFilter = selected;
          this.selectedStoreFilter = selected;
        }
      }
    }
    // save the filter name in the selector
    localStorage.setItem('selectedStoreFilter', JSON.stringify(this.selectedStoreFilter));
    this.filterDataByStore();
  }

  getSelectedStoresLabel(): string {
    const allIds = this.competitors.map(c => c.idConcorrente);
    const allSelected = allIds.every(id => this.selectedStore.includes(id));
  
    if (allSelected) 
      return 'Todas';

    const selectedStoreNames = this.selectedStore
      .map(id => this.competitors.find(c => c.idConcorrente === id)?.nomeConcorrente)
      .filter(name => name !== undefined);
  
    return selectedStoreNames.join(', ');
  }

  getSelectedLabLabel(): string {
    const allIds = this.laboratories.map(l => l.id);
    const allSelected = allIds.every(id => this.selectedLab.includes(id));
  
    if (allSelected) 
      return 'Todas';

    if (this.selectedLab.length > 1) 
      return `${this.selectedLab.length} selecionados`;

    const selectedStoreNames = this.selectedLab
      .map(id => this.laboratories.find(l => l.id === id)?.labName)
      .filter(name => name !== undefined);
  
    return selectedStoreNames.join(', ');
  }

  getSelectedStoresLabelFilter(): string {
    const allIds = this.competitors.map(c => c.idConcorrente);
    const allSelected = allIds.every(id => this.selectedStoreFilter.includes(id));
  
    if (allSelected) 
      return 'Todas';

    const selectedStoreNames = this.selectedStoreFilter
      .map(id => this.competitors.find(c => c.idConcorrente === id)?.nomeConcorrente)
      .filter(name => name !== undefined);
  
    return selectedStoreNames.join(', ');
  }
  
  filterDataByStore() {
    this.request.Page = 1;
    if (this.selectedStoreFilter[0] == 0) {
      this.selectedStoreFilter = [0]
    }
    var localstorage = localStorage.getItem('selectedStoreFilter')
    if (localstorage){
      this.storesFilter = JSON.parse(localstorage);
      this.selectedStoreFilter = JSON.parse(localstorage);
    }
    this.loadComparations();
  }

  loadCompetitors() {
    this.subscription.add(
      this.productComparatorService.getCompetitor().subscribe({
        next: (response) => {
          if (Array.isArray(response)) {
            response.forEach(item => {
              this.competitors.push({
                idConcorrente: item.idConcorrente,
                nomeConcorrente: item.nomeConcorrente,
                plataformaConcorrente: item.plataformaConcorrente,
                usernameConcorrente: item.usernameConcorrente,
                passwordConcorrente: item.passwordConcorrente
              });
              const allIds = this.competitors.map(c => c.idConcorrente);
              this.storesFilter = [0,...allIds];
              this.selectedStoreFilter = [0,...allIds];
            });
          } else {
            console.error('Wrong format:', response);
          }
        },
        error: (error) => {
          console.error('Error fetching competitors:', error);
        }
      })
    );
  }

  loadLaboratories() {
    this.subscription.add(
      this.productComparatorService.getLaboratory().subscribe({
        next: (response) => {
          if (Array.isArray(response)) {
            response.forEach(item => {
              this.laboratories.push({
                id: item.id,
                labName: item.labName
              });
            });
          } else {
            console.error('Wrong format:', response);
          }
        },
        error: (error) => {
          console.error('Error fetching laboratories:', error);
        }
      })
    );
  }

  updateChips(chips: string[]) {
    this.chipsList = chips;
  }

  addProductToComparator() {
    if ((this.chipsList.length > 0 || this.selectedLab.length > 0) && this.selectedStore.length > 0) {
      if (this.selectedStore[0] == 0)
        this.selectedStore = this.competitors.map(item => item.idConcorrente);
      if (this.selectedLab[0] == '0')
        this.selectedLab = this.laboratories.map(item => item.id);
      this.addProduct.ProductsIds = this.chipsList;
      this.addProduct.LabsIds = this.selectedLab;
      this.addProduct.CompetitorsIds = this.selectedStore;
      this.productComparatorService.addProductToComparator(this.addProduct)
        .subscribe({
          next: (response) => {
            if (!(response.successes.length === 0)){
              const succMessage = response.successes.join(', ');
              const errorMessage = response.errors.join(', ');
              this.snackBarService.openSnackBar(
                `${succMessage}. ${errorMessage}`,
                '#0AA174',
                '../../../../assets/Icons/correct.png',
              );
              this.loadComparations();
            }
            else{
              this.snackBarService.openSnackBar(
                  `Erro ao adicionar o(s) produto(s)!`,
                  '#F97066',
                  '../../../../assets/Icons/ErrorIcon.png'
                );
            }
          },
          error: (error) => {
            this.snackBarService.openSnackBar(
              `Erro ao adicionar produto(s) para comparação: ${error.message}`,
              '#F97066',
              '../../../../assets/Icons/ErrorIcon.png'
            );
          }
        });
    }
    else {
      this.snackBarService.openSnackBar(
        `Sem produto(s)/loja não selecionada para adicionar para comparação.`,
        '#F97066',
        '../../../../assets/Icons/ErrorIcon.png'
      );
    }
  }

  openModal(productData: ProductComparator) {
    console.log(productData);
    this.dialog.open(ComparatorModalComponent, {
      width: '900px',
      height: '600px',
      data: {
        productName: productData.nomeProdutoBio2,
        productId: productData.idProdutoBio2,
        competitorId: productData.idConcorrente,
        searchedName: productData.nomePesquisa,
        showData: productData.mostrarDados,
        searchAgain: productData.pesquisarNovamente,
        competitorName: productData.nomeConcorrente
      }});
  }

  filterProducts(query: string) {
    query = query.trim().toLowerCase();

    if (query.length >= 3) {
      this.request.FilterValue = query;
      if (this.isOnlyNumbers(query)) {
        this.request.FilterValue = query;
        this.request.FilterName = '';
      }
      else {
        this.request.FilterName = query;
        this.request.FilterValue = '';
      }
    }
    else {
      this.request.FilterValue = '';
      this.request.FilterName = '';
    }
    this.request.Page = 1;
    if (this.selectedStoreFilter[0] == 0)
      this.selectedStoreFilter = this.competitors.map(item => item.idConcorrente);
    this.loadComparations();
  }

  isOnlyNumbers(value: string): boolean {
    return /^\d+$/.test(value);
  }

  sortTable(sortColumn: string, sortOrder: string){
    this.request.Page = 1;
    this.request.SortColumn = sortColumn;
    this.request.SortOrder = sortOrder;
    this.loadComparations();
  }

  loadComparations() {
    this.loading = true;
    this.subscription.add(
      this.productComparatorService.getComparation(this.request, this.selectedStoreFilter).subscribe({
        next: (response: AllProductsComparator) => {
          this.productsComparator = response;
          this.nextPage = response.hasNextPage;
          this.apiResponse = response.totalCount;
          this.dataSourceComparator.data = this.productsComparator.data;         
        },
        error: (e) => console.error(e),
        complete: () => (
          this.loading = false,
          this.displayTable()
        ),
      })
    );
  }

  displayTable() {
    this.productsComparatorDisplay = this.productsComparator.data.slice(0,this.comparatorPageSize);
  }

  pageProductComparatorChanged(event: PageEvent) {
    this.request.PageSize = event.pageSize;
    this.request.Page = event.pageIndex + 1;
    this.subscription.add(
      this.productComparatorService.getComparation(this.request, this.selectedStoreFilter).subscribe({
        next: (response: AllProductsComparator) => {
          this.productsComparator = response;
          this.nextPage = response.hasNextPage;
          this.apiResponse = response.totalCount;
        },
        error: (e) => console.error(e),
        complete: () => (
          this.loading = false,
          this.displayTable()
        ),
      })
    );
  }

  downloadFile() {
    this.loading = true;
    this.productComparatorService.downloadFile(this.request, this.selectedStoreFilter)
    .subscribe({
      next: (response) => {
          const blob = new Blob([response.body], {type: 'text/csv'});
          const url = window.URL.createObjectURL(blob);
          const date = new Date();
          const dayStr = String(date.getDate()).padStart(2, '0');
          const monthStr = String(date.getMonth() + 1).padStart(2, '0');
          const yearStr = String(date.getFullYear());

          const formatted = `${dayStr}${monthStr}${yearStr}`;

          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `export_comparator_${formatted}`;
          downloadLink.click();  

          window.URL.revokeObjectURL(url);
        
          this.snackBarService.openSnackBar(
            `Ficheiro descarregado.`,
            '#0AA174',
            '../../../../assets/Icons/correct.png'
          );
          this.loading = false;
      },
      error: (error) => {
        console.error(error);
        this.snackBarService.openSnackBar(
          `Não foi possível exportar os dados da tabela.`,
          '#F97066',
          '../../../../assets/Icons/ErrorIcon.png'
        );
        this.loading = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription){
      this.subscription.unsubscribe();
    }
  }
}